module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAKFJREFUSEvN1bsNwzAMBNAjF7DLjJAyEKEBXGZqp1eRNiN4CiFQm8LiB4SjXvdAihAJyYeS83EtICI7gJWZn621w1PtaQUi8gbwAPBh5s2DnAK11lvvfVRx9yLTN4giU2D0PYKogAiiBryICfAgZsCK/B9gnShTBdbw0U414AlXA95wFRAJnwLR8CmQ/l2XUl5EtKQtHM8G+72jHlMvlg58AdtNlBl22Yl7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/home/more2.png
// module id = cbRm
// module chunks = 101